import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Functionality } from '../context/Functionality';

export default function ProtectedRoute({ children, employeeOnly = true }) {
    const { token, user, sessionReady } = useContext(Functionality);
    if (!sessionReady) return <p role="status" className="p-8">Checking account access…</p>;
    if (!token) return <Navigate to="/login" replace />;
    if (!user.emailVerified) return <Navigate to="/verify-email" replace />;
    if (employeeOnly && !user.isEmployee) return <Navigate to="/portal" replace />;
    return children;
}
